import { useEffect, useState } from 'react'
import {
  hasPushSynced,
  isIos,
  isMobile,
  isStandalone,
  shouldShowPushOptin,
  subscribePush,
} from '../lib/push'
import { promptInstallApp, shouldShowInstallOptin } from '../lib/pwaInstall'
import { useHubContext } from './HubLayout'

function safeNotificationGranted(): boolean {
  try {
    return typeof Notification !== 'undefined' && Notification.permission === 'granted'
  } catch {
    return false
  }
}

export function PwaOptinCard() {
  const { hub } = useHubContext()
  const [showPush, setShowPush] = useState(false)
  const [showInstall, setShowInstall] = useState(false)
  const [busy, setBusy] = useState<'push' | 'install' | ''>('')
  const [msg, setMsg] = useState('')
  const [err, setErr] = useState('')

  useEffect(() => {
    setShowPush(shouldShowPushOptin())
    setShowInstall(shouldShowInstallOptin())
    // Auto-sync só fora do iOS em aba (lá Push não funciona e redirecionava embora).
    if (isIos() && !isStandalone()) return
    if (safeNotificationGranted() && !hasPushSynced() && isMobile()) {
      void subscribePush()
        .then(() => setShowPush(false))
        .catch(() => setShowPush(true))
    }
  }, [])

  if (!showPush && !showInstall) return null

  const installLabel = hub?.campanha?.nome
    ? `Instalar App ${hub.campanha.nome}`
    : 'Instalar app'

  async function onPush() {
    setBusy('push')
    setErr('')
    setMsg('')
    try {
      if (isIos() && !isStandalone()) {
        window.location.href = '/instalar-app'
        return
      }
      await subscribePush()
      setShowPush(false)
      setMsg('Notificações ativadas!')
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Não foi possível ativar.')
    } finally {
      setBusy('')
    }
  }

  async function onInstall() {
    setBusy('install')
    setErr('')
    setMsg('')
    try {
      const outcome = await promptInstallApp({ campanhaId: hub?.campanha?.id })
      if (outcome === 'accepted' || outcome === 'guide') {
        setShowInstall(false)
      }
      if (outcome === 'accepted') {
        setMsg('App instalado!')
      }
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Não foi possível instalar.')
    } finally {
      setBusy('')
    }
  }

  return (
    <section className="bp-card">
      <p className="bp-card__eyebrow">App e avisos</p>
      <p className="bp-muted" style={{ marginTop: 0 }}>
        Instale na tela inicial e ative alertas da campanha neste aparelho.
      </p>
      <div className="bp-stack">
        {showInstall ? (
          <button type="button" className="bp-btn bp-btn--primary" disabled={busy === 'install'} onClick={() => void onInstall()}>
            <span className="bp-btn__icon" aria-hidden>
              ⬇
            </span>
            {busy === 'install' ? 'Aguardando Chrome…' : installLabel}
          </button>
        ) : null}
        {showPush ? (
          <button type="button" className="bp-btn bp-btn--push" disabled={busy === 'push'} onClick={() => void onPush()}>
            <span className="bp-btn__icon" aria-hidden>
              🔔
            </span>
            {busy === 'push' ? 'Ativando…' : 'Ativar notificações'}
          </button>
        ) : null}
      </div>
      {msg ? <p style={{ margin: '0.65rem 0 0', color: 'var(--bp-primary)', fontWeight: 700 }}>{msg}</p> : null}
      {err ? <p className="bp-error" style={{ margin: '0.65rem 0 0' }}>{err}</p> : null}
    </section>
  )
}
